import type { InvariantJiraRoute } from '@atlassian/jira-route-types/src/InvariantJiraRoute.tsx';

export const communicationsStatusPageManageRoute: InvariantJiraRoute = {
	name: 'communications-status-page-manage',
	path: '/jira/communications/status-page-manage',
};
